// noinspection JSUnresolvedReference

(function(app) {
    const elements = {};

    app.BoldToggle = {
        init() {
            elements.boldToggleEl = document.querySelector('.wdpp-checkbox--bold');
            elements.boldDisplayEl = document.querySelector('.wdpp-display--bold');
            console.log(elements.boldToggleEl);

            // Validate required elements
            if (!app.Utils.validateElements('bold inputs', {
                'bold toggle checkbox': '.wdpp-checkbox--bold',
                'bold display element': '.wdpp-display--bold'
            })) {
                return;
            }

            elements.boldToggleEl.addEventListener('change', () => {
                app.Store.setState('bold', elements.boldToggleEl.checked);
            });

            app.Store.subscribe('initialized', () => {
                app.Store.setState('bold', elements.boldToggleEl.checked);
            });

            // Subscribe to store changes
            app.Store.subscribe('bold', (value) => this.updateBoldDisplay(value));
        },

        updateBoldDisplay(isChecked) {
            if (elements.boldDisplayEl) {
                elements.boldDisplayEl.textContent = isChecked ? 'Ja' : 'Nej';
                elements.boldDisplayEl.classList.toggle('is-true', isChecked);
                elements.boldDisplayEl.classList.toggle('is-false', !isChecked);
            }
        },
        
        /**
         * Get the bold data for cart export
         * @returns {object} The bold data for the cart
         */
        getCartData() {
            return {
                bold: app.Store.getState('bold') || false,
            };
        },

        /**
         * Get the bold data for price calculation
         * @returns {object} The bold data for the price
         */
        getPriceData() {
            return {
                bold: app.Store.getState('bold') || false,
            };
        }
    };
})(window.app = window.app || {});